import React from 'react';

const ShapeCircle = () => (
    <svg width='189' height='55' viewBox='0 0 189 55' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M30.0296 52.1549C44.4318 52.1549 56.107 40.4796 56.107 26.0774C56.107 11.6753 44.4318 0 30.0296 0C15.6274 0 3.95215 11.6753 3.95215 26.0774C3.95215 40.4796 15.6274 52.1549 30.0296 52.1549Z'
            fill='#CCF3FF'
        />
        <path
            d='M27.0159 53.9997C41.3842 53.9997 53.0319 42.3519 53.0319 27.9837C53.0319 13.6155 41.3842 1.96777 27.0159 1.96777C12.6477 1.96777 1 13.6155 1 27.9837C1 42.3519 12.6477 53.9997 27.0159 53.9997Z'
            stroke='black'
            strokeWidth='1.5'
            strokeMiterlimit='10'
        />
        <ellipse cx='96.7252' cy='25.5273' rx='17.6727' ry='25.5273' fill='#F4C1C4' />
        <path
            d='M94.6216 1.73145C99.4213 1.73159 103.844 4.51597 107.098 9.1748C110.35 13.8313 112.385 20.3047 112.385 27.4902C112.385 34.6758 110.35 41.1491 107.098 45.8057C103.844 50.4646 99.4213 53.2499 94.6216 53.25C89.8217 53.25 85.398 50.4647 82.144 45.8057C78.892 41.1491 76.8569 34.6757 76.8569 27.4902C76.857 20.3047 78.8919 13.8313 82.144 9.1748C85.398 4.51578 89.8217 1.73145 94.6216 1.73145Z'
            stroke='black'
            strokeWidth='1.5'
        />
        <ellipse cx='162.844' cy='25.6907' rx='17.3571' ry='25.5536' transform='rotate(-90 162.844 25.6907)' fill='#FEE1BF' />
        <path
            d='M135.148 27.4814C135.148 22.7729 137.879 18.4324 142.453 15.2383C147.024 12.0459 153.379 10.0479 160.434 10.0479C167.489 10.0479 173.844 12.046 178.415 15.2383C182.988 18.4324 185.719 22.7729 185.719 27.4814C185.719 32.19 182.988 36.5305 178.415 39.7246C173.844 42.9169 167.489 44.915 160.434 44.915C153.379 44.915 147.024 42.917 142.453 39.7246C137.879 36.5305 135.148 32.19 135.148 27.4814Z'
            stroke='black'
            strokeWidth='1.5'
        />
    </svg>
);

export default ShapeCircle;
